// @flow

import type { AppConfiguration } from "./types";

export type AppState = {
  requestsInProgress: number,
  configuration: AppConfiguration,
};

export const initialState: AppState = {
  requestsInProgress: 0,
  configuration: {
    showNotificationContacts: false,
    showWorkRelatedWarning: false,
    showTriggeredAlerts: false,
    allowDocumentUpload: false,
    enableManagerMode: false,
  },
};

export default initialState;
